<template>
    <div id="container" style="width: 100%;height: 100%;"></div>
</template>

<script>
    export default {
        data() {
            return {
                isTransparent: false,
                scrollWheel: false

            }
        },
        mounted() {

            var map = new BMap.Map("container");
            var point = new BMap.Point(101.6773669,3.1163493);
            var marker = new BMap.Marker(point);  // 创建标注
            map.addOverlay(marker);              // 将标注添加到地图中
            map.centerAndZoom(point, 17);
            var opts = {
                width : 300,     // 信息窗口宽度
                height: 150,     // 信息窗口高度
                title : "<h1 style='margin-bottom: 10px;'>Malaysia</h1>"// 信息窗口标题
            }
            var infoWindow = new BMap.InfoWindow("S-084， Mid Valley Megamall，Level 31 Lingkaran Syed Putra59200 Kuala Lumpur, WilayahPersekutuan Kuala LumpurMalaysia", opts);  // 创建信息窗口对象
            map.openInfoWindow(infoWindow,point); //开启信息窗口
            marker.addEventListener("click", function(){
                map.openInfoWindow(infoWindow,point); //开启信息窗口
            });
        }
    }
</script>

<style>
    iframe{
        margin-top: 80px;
    }
</style>



// WEBPACK FOOTER //
// StoreMal.vue?12aa8c06